import { createApi } from '@reduxjs/toolkit/query/react';
import EnhancedBaseQuery from '../../Api/createApiConfig';

const posApi = createApi({
    reducerPath: 'posApi',
    baseQuery: EnhancedBaseQuery,
    endpoints: () => ({}),
});

const injectedPosApi = posApi.injectEndpoints({
    endpoints: (builder) => ({
        posList: builder.mutation({
            query: (config) => ({
                url: '/pos/search',
                method: 'POST',
                body: config,
            }),
        }),
        posAdd: builder.mutation({
            query: (config) => ({
                url: '/pos/add',
                method: 'POST',
                body: config,
            }),
        }),
    }),
    overrideExisting: false,
});
export const { usePosListMutation, usePosAddMutation } = injectedPosApi;
export default posApi;
